export const standardLimit = {
  oneUnitLimit: 766550,
  twoUnitLimit: 981500,
  threeUnitLimit: 1186350,
  fourUnitLimit: 1474400,
};
